import React, { useState } from 'react';
import { Card, Typography, Space, Divider, Tooltip, Row, Col, Modal, Button, Badge } from 'antd';
import { DollarCircleOutlined, GiftOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { ExpandOutlined, CompressOutlined } from '@ant-design/icons';
import { OfferCard } from './style';
import OfferList from './OfferList';
import CardList from './CardList';
const { Text } = Typography;

const OfferContent = ({ data, offerDetails }) => {
    return (
        <>
            {/* <Title level={4}>8 Month EMI - ₹{data?.emi_amount}</Title>
            <Title level={5}>{data?.model_name} - ₹{data?.model_price}</Title>
            <Divider style={{ margin: '8px 0' }} /> */}
            {offerDetails.map((offer, index) => (
                <Row key={index} className="offer-row" align="middle" gutter={[16, 8]}>
                    <Col xs={2} sm={1} className="icon-col">
                        <GiftOutlined className="gift-icon" />
                    </Col>
                    <Col xs={22} sm={7}>
                        <Text strong className="offer-mode">{offer.offer_mode}</Text>
                    </Col>
                    <Col xs={24} sm={6}>
                        <Text className="cashback-text">Cashback: ₹{parseInt(offer.cashback).toLocaleString()}</Text>
                    </Col>
                    <Col xs={24} sm={9}>
                        <Text className="price-text">
                            Effective Price: ₹{offer.effective_price.toLocaleString()}
                        </Text>
                    </Col>
                    <Col xs={24} sm={1} className="icon-col">
                        <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{offer.notes}</div>}>
                            <InfoCircleOutlined className="info-icon" />
                        </Tooltip>
                    </Col>
                </Row>
            ))}
        </>
    );
};


const OfferDetails = ({ data, offerListData }) => {

    const offerDetails = data?.offer_details || [];
    // const cardOfferList = offerListData?.card_offer_list || []
    const [expandedType, setExpandedType] = useState(null);
    const handleOfflineExpand = () => setExpandedType('offline');
    const handleOnlineExpand = () => setExpandedType('online');
    const handleMinimize = () => setExpandedType(null);

    const hasAnyOffers = Object.values(offerListData).some(
        (value) => Array.isArray(value) && value.length > 0
    );

    return (
        <>

            <OfferCard>
                {/* <CardList offerList={cardOfferList} setIsExpanded={setIsExpanded} /> */}
                {/* <br/> */}
                <>
                    {data && Array.isArray(offerDetails) && offerDetails.length > 0 &&
                        <Card className="offer-card" title={'OFFLINE OFFERS'}
                            extra={<Button type="text" icon={<ExpandOutlined />} onClick={handleOfflineExpand} />}
                            style={{ width: '100%', margin: '0 auto' }} >
                            <OfferContent data={data} offerDetails={offerDetails} />

                        </Card>
                    }
                </>
                {hasAnyOffers && offerListData &&

                    <Card
                        className="offer-card"
                        title={<><span>ONLINE OFFERS</span> <Tooltip title="Show Info">
                            {/* <Button
                                type="text"
                                icon={<InfoCircleOutlined />}
                                onClick={null}
                                style={{ fontSize: 16 }}
                            /> */}
                        </Tooltip></>}
                        style={{
                            borderRadius: 24,
                            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.05)',
                            padding: 12
                        }}
                        extra={<Button type="text" icon={<ExpandOutlined />} onClick={handleOnlineExpand} />}
                    >
                        <OfferList data={offerListData} />
                    </Card>

                }
                {/* </Card>} */}
            </OfferCard>

            <Modal
                open={!!expandedType}
                onCancel={handleMinimize}
                footer={
                    <Button icon={<CompressOutlined />} onClick={handleMinimize}>
                        Minimize
                    </Button>
                }
                width="90%"
                style={{ top: 30 }}
            >
                <OfferCard>
                    <Card
                        variant="borderless"
                        className="offer-card"
                        title={
                            expandedType === 'offline'
                                ? 'OFFLINE OFFERS'
                                : 'ONLINE OFFERS'
                        }
                    >
                        {expandedType === 'offline' && (
                            <OfferContent data={data} offerDetails={offerDetails} />
                        )}

                        {expandedType === 'online' && (
                            <OfferList data={offerListData} />
                        )}

                    </Card>
                </OfferCard>
            </Modal>



        </>

    )
}

export default OfferDetails